var _defs, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRomania = function SvgRomania(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Romania_svg__a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Romania_svg__b"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Romania_svg__f",
    cx: 100.2,
    cy: 100.2,
    r: 97.4,
    transform: "rotate(-45 100.202 100.195)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Romania_svg__c"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Romania_svg__f",
    cx: -119.8,
    cy: 99.9,
    r: 97.9,
    transform: "rotate(-45 -119.724 99.891)"
  })), /*#__PURE__*/React.createElement("style", null, ".Romania_svg__f{stroke-width:0;fill:none}"))), /*#__PURE__*/React.createElement("circle", {
    cx: 100.2,
    cy: 100.2,
    r: 97.4,
    transform: "rotate(-45 100.202 100.195)",
    style: {
      stroke: "#a5a7aa",
      strokeMiterlimit: 10,
      strokeWidth: "1.8px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#Romania_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      fill: "#feda00"
    },
    d: "M3.6 2.8h194.1v194.8H3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3454a5",
      strokeWidth: 0
    },
    d: "M3.6 2.8h64.7v194.8H3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed2024",
      strokeWidth: 0
    },
    d: "M132.9 2.8h64.7v194.8h-64.7z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Romania_svg__f",
    cx: 100.2,
    cy: 100.2,
    r: 97.4,
    transform: "rotate(-45 100.202 100.195)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#Romania_svg__c)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed2025",
      strokeWidth: 0
    },
    d: "M-250.5 2H43.1v195.7h-293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      strokeWidth: 0
    },
    d: "M-250.5 75.4H43.1v48.9h-293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f429b",
      strokeWidth: 0
    },
    d: "M-250.5 87.6H43.1v24.5h-293.6z"
  })));
};
export default SvgRomania;